define([], function() {
    return function(inputstr) {
        if (inputstr instanceof Date) {
            return new Date(+inputstr);
        } else if ((inputstr || '').match(/^\d{1,2}\.\d{1,2}\.\d{4}$/)) { // дд.мм.гггг
            const parts = inputstr.split('.').map(n => parseInt(n, 10) );
            return new Date(parts[2], parts[1] - 1, parts[0]);
        } else if ((inputstr || '').match(/^\d{4}-\d{2}-\d{2}$/)) { // гггг-мм-дд
            const parts = inputstr.split('-').map(n => parseInt(n, 10) );
            return new Date(parts[0], parts[1] - 1, parts[2]);
        }

        throw "Не могу конвертировать строку " + inputstr;
    };
});
